module.exports = __webpack_public_path__ + "img/disco-rhythm.c7296659.png";